/**
 * vue 全局请求
 * this.$http(url, data , method)
 */
import axios from "axios";
import { getToken } from "./auth";
import { Message } from "element-ui";
import router from "@/router/premission.js";
import { GetRequest } from "@/utils/auth.js";
import qs from "qs";
const instance = axios.create();
instance.defaults.timeout = 15000;
instance.defaults.baseURL = process.env.DEV_API; // 填写域名
let pending = []; // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken;
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + "&" + config.method) {
      // 当当前请求在数组中存在时执行函数体
      pending[p].f(); // 执行取消操作
      pending.splice(p, 1); // 把这条记录从数组中移除
    }
  }
};
// http request 拦截器
instance.interceptors.request.use(
  (config) => {
    removePending(config); // 在一个ajax发送前执行一下取消操作
    config.cancelToken = new CancelToken(
      (c) => {
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
        pending.push({ u: config.url + "&" + config.method, f: c });
      },
      (err) => {
        console.log(err);
      }
    );
    config.headers["token"] = getToken();
    config.headers["dc-client"] = "21";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截器即异常处理
instance.interceptors.response.use(
  (res) => {
    if (typeof res.data === "string") {
      res.data = JSON.parse(res.data);
      console.log(res.data[10]);
    }

    // http 状态码【错误提示】
    if (res.status != 200) {
      Message({
        message: res.statusText,
        type: "error",
      });
    }

    let status = res.data.status ? res.data.status : res.data.code;
    let message = res.data.error ? res.data.error : "";
    if (status !== 0) {
      // token无效 跳转到登陆 或者为单点登录时 异常就跳转到登陆
      if (status === 4012 || GetRequest("token") || status === 4012) {
        Message({
          message: "用户信息失效,请重新登陆",
          type: "error",
          duration: 3 * 1000,
        });
        setTimeout(() => {
          router.push({ name: "login" });
          window.location.reload();
        }, 1000);
      } else {
        if (message) {
          Message({
            message: message,
            type: "error",
            duration: 3 * 1000,
          });
        }
      }
      // 如果有错误则抛出
      if (res && res.data.error) throw new Error(res.data.error);
    }
    removePending(res.config); // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    return res.data;
  },
  (err) => {
    let errmsg = "";
    if (Object.is(err.message, undefined)) {
      errmsg = "请不要重复操作";
    } else {
      errmsg = err.response.data.error;
    }
    Message({
      message: errmsg,
      type: "error",
      duration: 3 * 1000,
    });
    if (err.response.data.status === 401) router.push({ name: "login" });
    return Promise.reject(err);
  }
);

function fetch(url, params, method = "post", isformdata = false, config = {}) {
  // let postdata = {
  //   data: params
  // }
  // if (method === 'get') {
  //   postdata = {
  //     params: params
  //   }
  // }
  if (method === "post" && isformdata) {
    config.data = qs.stringify(params)
    let urlx = new URL(url, 'http://localhost')
    for (let key in params) {
      urlx.searchParams.set(key, params[key])
    }
    url = urlx.pathname + '?' + urlx.searchParams.toString()
  }
  return new Promise((resolve, reject) => {
    instance({
      url,
      method,
      data: method === "post" || method === "delete" ? params : {},
      params: method === "get" ? params : {},
      ...config,
    })
      .then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      )
      .catch((error) => {
        reject(error);
      });
  });
}
/**
 * 参数(url, params, method = 'post', isformdata = false, config = {})
 */
export default fetch;



// WEBPACK FOOTER //
// ./src/utils/http-service.js